import {useNavigate, Routes, Route, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useLogout from "../../hooks/useLogout";
import PageHeader from "../layout/PageHeader";
import LayoutSidebarLeft from "../layout/LayoutSidebarLeft";
import React from "react";



const App = () => {
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    navigate('/homepage');
  }

  return (
    <>
      <PageHeader valid={ true }/>
        <div id="layoutSidenav">
          <LayoutSidebarLeft />
            {/*<Routes>*/}
            {/*  <Route path='/app/*' element={<Outlet />} />*/}
            {/*</Routes>*/}
          <Outlet />
        </div>
    </>
  )
}

export default App